type IApiStatus =
  | 'pending'
  | 'booked'
  | 'approved'
  | 'rejected'
  | 'Paid'
  | 'Unpaid'
  | 'Partial Paid'
  | 'Under Review'
  | null
  | undefined
  | '';

const CommonStatus = (apiStatus: IApiStatus) => {
  // Define all possible statuses including fallback
  const status: Record<
    Exclude<IApiStatus, null | undefined | ''>,
    { text: string }
  > = {
    pending: {
      text: 'Pending',
    },
    booked: {
      text: 'Booked',
    },
    approved: {
      text: 'Approved',
    },
    Paid: {
      text: 'Paid',
    },
    Unpaid: {
      text: 'Unpaid',
    },
    'Partial Paid': {
      text: 'Partial Paid',
    },
    'Under Review': {
      text: 'Under Review',
    },
    rejected: {
      text: 'Rejected',
    },
  };

  // Handle null/undefined/empty cases
  if (!apiStatus) {
    return <span className='unknown-status'>Unknown</span>;
  }

  // Get the status or fallback to unknown
  const currentStatus = status[apiStatus] || { text: 'Unknown' };

  return (
    <span
      className={
        apiStatus === 'pending'
          ? 'pending'
          : apiStatus === 'approved'
          ? 'approved'
          : apiStatus === 'rejected'
          ? 'rejected'
          : apiStatus === 'booked'
          ? 'booked'
          : apiStatus === 'Paid'
          ? 'approved'
          : apiStatus === 'Unpaid'
          ? 'rejected'
          : apiStatus === 'Partial Paid'
          ? 'booked'
          : apiStatus === 'Under Review'
          ? 'rejected'
          : 'unknown-status'
      }
    >
      {currentStatus.text}
    </span>
  );
};

export default CommonStatus;
